export var RUMEventName;
(function (RUMEventName) {
    RUMEventName["AddError"] = "ADD_ERROR";
    RUMEventName["SetUser"] = "SET_USER";
    RUMEventName["ClearUser"] = "CLEAR_USER";
    RUMEventName["SetContext"] = "SET_CONTEXT";
    RUMEventName["AddAction"] = "ADD_ACTION";
    RUMEventName["SetRouteName"] = "SET_ROUTE_NAME";
    RUMEventName["AddTiming"] = "ADD_TIMING";
})(RUMEventName || (RUMEventName = {}));
//# sourceMappingURL=types.js.map